import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
    static targets = ['button', 'menu']
    static values = {
        labelOpened: { type: String, default: 'Menü öffnen'},
        labelClosed: { type: String, default: 'Menü schließen'},
    }

    connect() {
        this.raf = true;

        window.requestAnimationFrame(this._raf.bind(this));
    }

    toggle() {
        document.body.classList.toggle('show-top-creators-2025-menu');

        if (document.body.classList.contains('show-top-creators-2025-menu')) {
            this.buttonTarget?.setAttribute('aria-expanded', 'true');
            this.buttonTarget?.setAttribute('aria-label', this.labelClosedValue);
        } else {
            this.buttonTarget?.setAttribute('aria-expanded', 'false');
            this.buttonTarget?.setAttribute('aria-label', this.labelOpenedValue);
        }
    }

    close() {
        document.body.classList.remove('show-top-creators-2025-menu');
        this.buttonTarget?.setAttribute('aria-expanded', 'false');
        this.buttonTarget?.setAttribute('aria-label', this.labelOpenedValue);
    }

    buttonTargetDisconnected(button) {
        button.setAttribute('aria-expanded', 'false');
        button.setAttribute('aria-label', this.labelOpenedValue);
    }

    menuTargetDisconnected() {
        this.raf = false;
    }

    search(event) {
        this.dispatch('search', { detail: event.target.value });
    }

    disconnect() {
        document.body.classList.remove('show-top-creators-2025-menu');
    }

    _raf() {
        this.menuTarget?.classList.remove('fixed');
        const headerHeight = document.getElementById('header')?.getBoundingClientRect().height ?? 0;
    
        if (this.menuTarget?.getBoundingClientRect().top <= headerHeight) {
            this.menuTarget?.classList.add('fixed');
        }

        if (this.raf) {
            window.requestAnimationFrame(this._raf.bind(this));
        }
    }
}
